import * as React from 'react'
import { cn } from '@/lib/utils'
import { fmtCZK } from './helpers'

// Price pill overlaid on a photo — cards.jsx:19-26. Parent must be relative.
export function PricePill({ price }: { price: number }) {
  return (
    <div className="absolute bottom-3 left-3 flex items-baseline gap-1 rounded-[10px] bg-[rgba(26,23,23,0.85)] px-[10px] py-[6px]">
      <span className="font-mono text-[15.5px] font-bold text-white">{fmtCZK(price)}</span>
      <span className="font-mono text-[11px] text-white/80">/mo</span>
    </div>
  )
}

// Deal dot from the price percentile — cards.jsx:120-131. Green = great deal
// (percentile ≤ 33), amber = premium (≥ 70), nothing in between.
export interface DealDotProps {
  listing: { percentile?: number | null }
  size?: number
}

export function DealDot({ listing, size = 7 }: DealDotProps) {
  const p = listing.percentile
  if (p == null) return null
  const good = p <= 33
  const premium = p >= 70
  if (!good && !premium) return null
  return (
    <span
      title={
        good
          ? `Great deal — cheaper than ${100 - p}% of similar homes`
          : `Premium — pricier than ${p}% of similar homes`
      }
      className={cn('inline-block shrink-0 self-center rounded-full', good ? 'bg-success' : 'bg-warning')}
      style={{ width: size, height: size }}
    />
  )
}
